export default function(RootModel) {

  /**
   * EventModel Class
   *
   * @public
   * @class EventModel
   */
  return class EventModel extends RootModel {

    /**
     * EventModel constructor
     *
     * @public
     * @constructor
     * @param {Object} options - Options
     */
    constructor(options = {}) {
      super(Object.assign({}, {
        table: 'events',

        permissions: {
          create:  ['public'],
          delete:  ['admin'],
          read:    ['admin'],
          replace: ['admin'],
          update:  ['admin'],
        }
      }, options))
    }

  }

}
